import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { SiMicrosoftexcel } from 'react-icons/si';
import { BsFiletypePdf } from 'react-icons/bs';
import './ExportModal.scss';

interface ExportModalProps {
  show: boolean;
  onHide: () => void;
  onExportExcel: () => void;
  onExportPdf: () => void;
  title?: string;
}

const ExportModal: React.FC<ExportModalProps> = ({
  show,
  onHide,
  onExportExcel,
  onExportPdf,
  title = 'Export Data'
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="export-modal"
      size="sm"
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="export-options">
          <button
            className="export-option excel-option"
            onClick={() => {
              onExportExcel();
              onHide();
            }}
          >
            <div className="export-icon-wrapper excel-icon">
              <SiMicrosoftexcel size={32} />
            </div>
            <div className="export-option-content">
              <h6>Export as Excel</h6>
              <p>Download data in .xlsx format</p>
            </div>
          </button>

          <button
            className="export-option pdf-option"
            onClick={() => {
              onExportPdf();
              onHide();
            }}
          >
            <div className="export-icon-wrapper pdf-icon">
              <BsFiletypePdf size={32} />
            </div>
            <div className="export-option-content">
              <h6>Export as PDF</h6>
              <p>Download data in .pdf format</p>
            </div>
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ExportModal;
